import { Link } from "react-router-dom";
import failedIcon from "../../assets/icons/failed.svg"; // You'll need to add this icon

function Failed() {
	return (
		<div className='min-h-screen flex items-center justify-center bg-[#FFF5F5]'>
			<div className='text-center p-8 max-w-2xl mx-auto'>
				<div className='mb-6'>
					<img
						src={failedIcon}
						alt='Failed'
						className='w-20 h-20 mx-auto mb-4'
					/>
				</div>
				<h1 className='text-3xl font-bold text-[#11112D] mb-4'>
					Donation Not Completed
				</h1>
				<p className='text-[#43474F] mb-6 text-lg'>
					We noticed that your donation process wasn't completed. This could
					happen for various reasons. Don't worry - no charges have been made to
					your account.
				</p>
				<div className='bg-white p-6 rounded-lg mb-8 shadow-sm'>
					<h2 className='font-semibold text-lg mb-3 text-[#11112D]'>
						What would you like to do?
					</h2>
					<ul className='text-[#43474F] text-left list-disc list-inside mb-4'>
						<li>Try donating again</li>
						<li>Contact our support team</li>
						<li>Learn more about our mission</li>
					</ul>
				</div>
				<div className='flex flex-col sm:flex-row gap-4 justify-center'>
					<Link
						to='/donate'
						className='px-6 py-3 bg-[#0F713E] text-white rounded-full hover:bg-[#0a5a32] transition-colors'>
						Try Again
					</Link>
					<Link
						to='/contact'
						className='px-6 py-3 border-2 border-[#0F713E] text-[#0F713E] rounded-full hover:bg-[#0F713E] hover:text-white transition-colors'>
						Contact Support
					</Link>
				</div>
			</div>
		</div>
	);
}

export default Failed;
